export default __webpack_public_path__ + "static/media/hero 333.c70002a0.jpg";